module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_1.f3b1b3ce.png";